module.exports = __webpack_public_path__ + "img/contactsview_blur.cc606a6e.png";